/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import { Location } from "SearchParameters";
import { Autocomplete, IconButton, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getAllLocations } from "../../../api";
import { AxiosError } from "axios";
import { East } from "@mui/icons-material";

interface BookingLocationProps {
  fromLocation: Location | null;
  onFromLocationChange: any;
  fromLabel?: string;
  toLocation: Location | null;
  onToLocationChange: any;
  toLabel?: string;
  onError: any;
  specialButtonAction: any;
}

//TODO: Separate AutoComplete further
const BookingLocation = (props: BookingLocationProps) => {
  const { data: dropdownLocations, isLoading: locationsLoading } = useQuery({
    queryFn: getAllLocations,
    queryKey: ["getAllLocations"],
    refetchOnWindowFocus: false,
    initialData: [],
    onError: (error: AxiosError) => props.onError(error),
  });

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: 10,
      }}
    >
      <div
        style={{
          width: "45%",
        }}
      >
        <Autocomplete
          value={props.fromLocation ?? null}
          onChange={props.onFromLocationChange}
          getOptionLabel={(option: Location) => option.location}
          isOptionEqualToValue={(option: Location, value: Location) =>
            option.location === value.location
          }
          options={dropdownLocations}
          loading={locationsLoading}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label={props.fromLabel ?? "From"}
            />
          )}
        />
      </div>
      <IconButton color="primary" onClick={props.specialButtonAction}>
        <East fontSize="small" />
      </IconButton>
      <div
        style={{
          width: "45%",
        }}
      >
        <Autocomplete
          value={props.toLocation ?? null}
          onChange={props.onToLocationChange}
          getOptionLabel={(option: Location) => option.location}
          isOptionEqualToValue={(option: Location, value: Location) =>
            option.location === value.location
          }
          options={dropdownLocations}
          loading={locationsLoading}
          renderInput={(params) => (
            <TextField {...params} size="small" label={props.toLabel ?? "To"} />
          )}
        />
      </div>
    </div>
  );
};

export default BookingLocation;
